<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Validación de firma electrónica de documentos</span>
      </h5>
    </div>
    <b-table striped hover stacked :items="items" responsive>
      <template #cell(url)="element">
        <a :href="element.item.url" target="_blank">Descargar documento</a>.
      </template>
    </b-table>
  </div>
</template>

<script>
import apiClient2 from '@/services/axios/v2.js'
import axios from 'axios'

export default {
  name: 'closingPurchaseOrder',
  data() {
    return {
      urlData: {
        fileName: '',
        dateSigned: '',
        userFullName: '',
        url: '',
      },
      templateFileUser: null,
      items: [{
        document: '',
        date: '',
        name: '',
        nip: '',
        url: '',
      }],
    }
  },
  beforeRouteEnter (to, from, next) {
    function getTemplateFileUser() {
      console.log(to.params.idTemplateFileUser)
      return apiClient2.get('enrollments/enrollment-templates/signed-file/' + to.params.idTemplateFileUser)
    }

    axios.all([getTemplateFileUser()])
      .then(axios.spread(function (templateFileUserInfo) {
        next((vm) => {
          vm.setTemplateFileUser(null, templateFileUserInfo)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setTemplateFileUser(err, [])
        })
      })
  },
  methods: {
    setTemplateFileUser (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.items[0].document = data.data.data.fileName
        this.items[0].date = data.data.data.dateSigned
        this.items[0].name = data.data.data.userFullName
        this.items[0].nip = data.data.data.userCc
        this.items[0].url = data.data.data.url
        console.log('this.items', this.items)
      }
    },
  },
}
</script>
